import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";


@Injectable({ providedIn: "root" })
export class AdminPortalAPIHttpClient {
 
    constructor(private http: HttpClient) { }

    post(url: string, body: any, headers?: any) {
        return this.http.post(this.getBaseApiUrl() + url, body, {headers: headers});
    }

    get(url: string, params?: { params: any; } | null, response?: any) {
        if(params === null || params === undefined) {
            return this.http.get(this.getBaseApiUrl() + url);   
        }

        const httpParams = new HttpParams().appendAll(params.params);
        return this.http.get(this.getBaseApiUrl() + url, { 
            params: httpParams, 
            responseType: response == null ? 'json' : response 
        });
    }

    put(url: string, body: any) {
        return this.http.put(this.getBaseApiUrl() + url, body);
    }

    delete(url: string) {
        return this.http.delete(this.getBaseApiUrl() + url);
    }

    getBaseApiUrl(): string {
        return environment.portalConfig.adminPortalBaseUrl ?? '';
    }
}